<template>
  <div class="sourcing-page">
    <!-- 顶部统计卡片 -->
    <div class="stat-row">
      <div v-for="(item, index) in statCards" :key="index" class="stat-card">
        <div class="stat-left">
          <div class="stat-value" :style="{ color: item.color }">{{ item.value }}</div>
          <div class="stat-label">{{ item.label }}</div>
        </div>
        <div class="stat-icon" :style="{ background: item.bgColor, color: item.color }">{{ item.icon }}</div>
      </div>
    </div>

    <!-- 第一行：寻源方式占比 + 采购金额对比 -->
    <div class="chart-row">
      <div class="chart-box chart-small">
        <div class="chart-header">
          <span class="chart-title">◈ 寻源方式占比</span>
        </div>
        <div ref="chartMethod" class="chart-body"></div>
      </div>
      <div class="chart-box chart-large">
        <div class="chart-header">
          <span class="chart-title">◉ 各品类采购金额对比</span>
          <span class="chart-sub">单位：万元</span>
        </div>
        <div ref="chartAmount" class="chart-body"></div>
      </div>
    </div>

    <!-- 第二行：竞价趋势 + 节资率分析 -->
    <div class="chart-row">
      <div class="chart-box chart-medium">
        <div class="chart-header">
          <span class="chart-title">▣ 竞价采购节资率趋势</span>
        </div>
        <div ref="chartSaveRate" class="chart-body"></div>
      </div>
      <div class="chart-box chart-medium">
        <div class="chart-header">
          <span class="chart-title">◆ 询比价响应时效</span>
        </div>
        <div ref="chartResponse" class="chart-body"></div>
      </div>
    </div>

    <!-- 底部：进行中的寻源项目列表 -->
    <div class="chart-box table-box">
      <div class="chart-header">
        <span class="chart-title">◊ 进行中的寻源项目</span>
        <div class="table-actions">
          <button class="action-btn" @click="handleNewProject">新建项目</button>
          <button class="action-btn" @click="handleExport">导出数据</button>
        </div>
      </div>
      <div class="table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>项目编号</th>
              <th>项目名称</th>
              <th>寻源方式</th>
              <th>采购品类</th>
              <th>预算金额</th>
              <th>参与供应商</th>
              <th>截止时间</th>
              <th>项目状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in projectList" :key="idx">
              <td class="code-cell">{{ item.code }}</td>
              <td class="name-cell">
                <div class="project-name">{{ item.name }}</div>
              </td>
              <td>
                <span class="method-tag" :class="item.method">{{ methodText(item.method) }}</span>
              </td>
              <td><span class="tag-category">{{ item.category }}</span></td>
              <td class="amount-cell">{{ item.budget }}</td>
              <td>
                <div class="supplier-progress">
                  <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: (item.joined / item.totalSupplier * 100) + '%' }"></div>
                  </div>
                  <span class="progress-text">{{ item.joined }}/{{ item.totalSupplier }}</span>
                </div>
              </td>
              <td class="time-cell" :class="{ urgent: item.isUrgent }">{{ item.deadline }}</td>
              <td>
                <span class="status-badge" :class="item.status">{{ statusText(item.status) }}</span>
              </td>
              <td>
                <button class="op-btn primary" @click="handleView(item)">查看</button>
                <button class="op-btn" @click="handleInvite(item)">邀请</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer">
        <span class="footer-info">共 {{ projectList.length }} 条记录</span>
        <div class="pagination">
          <button class="page-btn" :disabled="currentPage === 1" @click="currentPage--">←</button>
          <span class="page-num" v-for="p in pageList" :key="p" :class="{ active: p === currentPage }" @click="currentPage = p">{{ p }}</span>
          <button class="page-btn" :disabled="currentPage === totalPage" @click="currentPage++">→</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SrmSourcing',
  data() {
    return {
      statCards: [
        { label: '本月寻源项目', value: '28', icon: '◈', color: '#00d4ff', bgColor: 'rgba(0, 212, 255, 0.1)' },
        { label: '招标中项目', value: '8', icon: '◎', color: '#f0a030', bgColor: 'rgba(240, 160, 48, 0.1)' },
        { label: '询比价中', value: '12', icon: '◉', color: '#00e5a0', bgColor: 'rgba(0, 229, 160, 0.1)' },
        { label: '竞价中项目', value: '5', icon: '▣', color: '#ff6b9d', bgColor: 'rgba(255, 107, 157, 0.1)' },
        { label: '累计节资金额', value: '¥3,680万', icon: '◆', color: '#a855f7', bgColor: 'rgba(168, 85, 247, 0.1)' },
        { label: '平均节资率', value: '18.6%', icon: '◊', color: '#00e5a0', bgColor: 'rgba(0, 229, 160, 0.1)' }
      ],
      projectList: [
        { code: 'SRC-2026-0089', name: '2026年度电子元器件集中采购', method: 'bidding', category: '电子元器件', budget: '¥2,500万', joined: 12, totalSupplier: 15, deadline: '2026-07-05 14:00', isUrgent: false, status: 'bidding' },
        { code: 'SRC-2026-0088', name: 'Q3机械零部件询比价采购', method: 'inquiry', category: '机械加工', budget: '¥860万', joined: 8, totalSupplier: 10, deadline: '2026-06-28 10:00', isUrgent: true, status: 'quoting' },
        { code: 'SRC-2026-0087', name: '化工原材料竞价采购项目', method: 'auction', category: '化工材料', budget: '¥1,200万', joined: 6, totalSupplier: 8, deadline: '2026-06-27 16:00', isUrgent: true, status: 'auctioning' },
        { code: 'SRC-2026-0086', name: '包装材料年度框架协议招标', method: 'bidding', category: '包装材料', budget: '¥680万', joined: 5, totalSupplier: 12, deadline: '2026-07-10 09:00', isUrgent: false, status: 'bidding' },
        { code: 'SRC-2026-0085', name: '物流运输服务询比价', method: 'inquiry', category: '物流运输', budget: '¥420万', joined: 4, totalSupplier: 6, deadline: '2026-06-30 15:00', isUrgent: false, status: 'quoting' },
        { code: 'SRC-2026-0084', name: '智能设备零部件竞价采购', method: 'auction', category: '智能装备', budget: '¥350万', joined: 7, totalSupplier: 10, deadline: '2026-06-26 11:00', isUrgent: true, status: 'auctioning' },
        { code: 'SRC-2026-0083', name: '办公用品集中采购招标', method: 'bidding', category: '办公用品', budget: '¥120万', joined: 9, totalSupplier: 15, deadline: '2026-07-08 17:00', isUrgent: false, status: 'bidding' },
        { code: 'SRC-2026-0082', name: '金属原材料询比价项目', method: 'inquiry', category: '金属加工', budget: '¥580万', joined: 6, totalSupplier: 8, deadline: '2026-07-02 14:00', isUrgent: false, status: 'quoting' }
      ],
      currentPage: 1,
      totalPage: 3,
      charts: {}
    }
  },
  computed: {
    pageList() {
      return [1, 2, 3]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMethodChart()
      this.initAmountChart()
      this.initSaveRateChart()
      this.initResponseChart()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.charts).forEach(chart => chart && chart.dispose())
  },
  methods: {
    handleResize() {
      Object.values(this.charts).forEach(chart => chart && chart.resize())
    },
    methodText(method) {
      const map = { bidding: '公开招标', inquiry: '询比价', auction: '竞价采购', frame: '框架协议' }
      return map[method] || method
    },
    statusText(status) {
      const map = { bidding: '招标中', quoting: '报价中', auctioning: '竞价中', evaluating: '评标中', finished: '已完成' }
      return map[status] || status
    },
    handleNewProject() {
      alert('打开新建寻源项目弹窗')
    },
    handleExport() {
      alert('正在导出寻源项目数据...')
    },
    handleView(item) {
      alert(`查看项目详情：${item.name}\n\n项目编号：${item.code}\n预算金额：${item.budget}\n参与供应商：${item.joined}/${item.totalSupplier}`)
    },
    handleInvite(item) {
      alert(`邀请更多供应商参与：${item.name}`)
    },

    // 寻源方式占比（饼图）
    initMethodChart() {
      const chart = this.$echarts.init(this.$refs.chartMethod)
      this.charts.method = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          formatter: '{b}: {c}个 ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: { color: '#8c9bb3', fontSize: 11 },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [{
          type: 'pie',
          radius: ['40%', '65%'],
          center: ['35%', '50%'],
          avoidLabelOverlap: false,
          label: { show: false },
          labelLine: { show: false },
          data: [
            { value: 8, name: '公开招标', itemStyle: { color: '#00d4ff' } },
            { value: 12, name: '询比价', itemStyle: { color: '#00e5a0' } },
            { value: 5, name: '竞价采购', itemStyle: { color: '#ff6b9d' } },
            { value: 3, name: '框架协议', itemStyle: { color: '#f0a030' } }
          ]
        }]
      })
    },

    // 各品类采购金额对比（分组柱状图）
    initAmountChart() {
      const chart = this.$echarts.init(this.$refs.chartAmount)
      this.charts.amount = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' }
        },
        legend: {
          data: ['预算金额', '成交金额'],
          textStyle: { color: '#8c9bb3' },
          right: 10,
          top: 0
        },
        grid: { left: 50, right: 20, top: 40, bottom: 25 },
        xAxis: {
          type: 'category',
          data: ['电子元器件', '机械加工', '化工材料', '包装材料', '物流运输', '智能装备', '办公用品', '金属加工'],
          axisLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.2)' } },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        series: [
          {
            name: '预算金额',
            type: 'bar',
            barWidth: 14,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00d4ff' },
                { offset: 1, color: 'rgba(0, 212, 255, 0.2)' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            data: [2500, 860, 1200, 680, 420, 350, 120, 580]
          },
          {
            name: '成交金额',
            type: 'bar',
            barWidth: 14,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00e5a0' },
                { offset: 1, color: 'rgba(0, 229, 160, 0.2)' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            data: [2180, 720, 980, 590, 365, 298, 105, 495]
          }
        ]
      })
    },

    // 竞价采购节资率趋势（折线图 + 面积）
    initSaveRateChart() {
      const chart = this.$echarts.init(this.$refs.chartSaveRate)
      this.charts.saveRate = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          formatter: '{b}<br/>节资率: {c}%'
        },
        grid: { left: 50, right: 30, top: 30, bottom: 25 },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
          axisLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.2)' } },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          max: 30,
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 11, formatter: '{value}%' },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        series: [{
          name: '节资率',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: { color: '#a855f7', width: 3 },
          itemStyle: { color: '#a855f7', borderColor: '#fff', borderWidth: 2 },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(168, 85, 247, 0.35)' },
              { offset: 1, color: 'rgba(168, 85, 247, 0)' }
            ])
          },
          data: [12.5, 15.2, 14.8, 18.3, 16.7, 18.6]
        }]
      })
    },

    // 询比价响应时效（箱线图简化版 - 用柱状图模拟）
    initResponseChart() {
      const chart = this.$echarts.init(this.$refs.chartResponse)
      this.charts.response = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          formatter: '{b}<br/>平均响应: {c}小时'
        },
        grid: { left: 50, right: 30, top: 30, bottom: 25 },
        xAxis: {
          type: 'category',
          data: ['电子元器件', '机械加工', '化工材料', '包装材料', '物流运输', '智能装备'],
          axisLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.2)' } },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 11, formatter: '{value}h' },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        series: [{
          type: 'bar',
          barWidth: 20,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#f0a030' },
              { offset: 1, color: 'rgba(240, 160, 48, 0.2)' }
            ]),
            borderRadius: [4, 4, 0, 0]
          },
          data: [18, 24, 36, 12, 8, 42],
          label: {
            show: true,
            position: 'top',
            color: '#f0a030',
            fontSize: 11,
            formatter: '{c}h'
          }
        }]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sourcing-page {
  width: 100%;
  min-height: 100%;
  padding-bottom: 20px;
}

/* ==================== 统计卡片 ==================== */
.stat-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.stat-card {
  background: rgba(0, 212, 255, 0.04);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.07);
    border-color: rgba(0, 212, 255, 0.2);
    transform: translateY(-2px);
  }
}

.stat-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
}

.stat-label {
  font-size: 12px;
  color: #8c9bb3;
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

/* ==================== 图表行 ==================== */
.chart-row {
  display: grid;
  gap: 16px;
  margin-bottom: 16px;

  &:nth-of-type(2) {
    grid-template-columns: 1fr 2fr;
  }

  &:nth-of-type(3) {
    grid-template-columns: 1fr 1fr;
  }
}

.chart-box {
  background: rgba(0, 212, 255, 0.03);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.chart-title {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
}

.chart-sub {
  font-size: 11px;
  color: #8c9bb3;
}

.chart-body {
  flex: 1;
  min-height: 240px;
}

/* ==================== 表格区域 ==================== */
.table-box {
  min-height: 400px;
}

.table-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid rgba(0, 212, 255, 0.4);
  background: rgba(0, 212, 255, 0.08);
  color: #00d4ff;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.15);
    box-shadow: 0 0 10px rgba(0, 212, 255, 0.2);
  }
}

.table-wrap {
  flex: 1;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 212, 255, 0.05);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 212, 255, 0.2);
    border-radius: 2px;
  }
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th, td {
    padding: 12px 14px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 212, 255, 0.08);
    white-space: nowrap;
  }

  th {
    background: rgba(0, 212, 255, 0.06);
    color: #8c9bb3;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 1px;
  }

  tbody tr {
    transition: all 0.2s;

    &:hover {
      background: rgba(0, 212, 255, 0.04);
    }
  }
}

.code-cell {
  color: #8c9bb3;
  font-family: 'Courier New', monospace;
  font-size: 12px;
}

.name-cell {
  .project-name {
    color: #fff;
    font-size: 13px;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.amount-cell {
  color: #00d4ff;
  font-weight: bold;
}

.time-cell {
  &.urgent {
    color: #ff6b6b;
    font-weight: bold;
  }
}

.method-tag {
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;

  &.bidding {
    background: rgba(0, 212, 255, 0.1);
    color: #00d4ff;
  }

  &.inquiry {
    background: rgba(0, 229, 160, 0.1);
    color: #00e5a0;
  }

  &.auction {
    background: rgba(255, 107, 157, 0.1);
    color: #ff6b9d;
  }

  &.frame {
    background: rgba(240, 160, 48, 0.1);
    color: #f0a030;
  }
}

.tag-category {
  padding: 2px 10px;
  border-radius: 4px;
  background: rgba(0, 212, 255, 0.08);
  color: #8c9bb3;
  font-size: 12px;
}

.supplier-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 100px;
}

.progress-bar {
  flex: 1;
  height: 6px;
  background: rgba(140, 155, 179, 0.15);
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #00d4ff, #00e5a0);
  border-radius: 3px;
  transition: width 0.5s ease;
}

.progress-text {
  font-size: 11px;
  color: #8c9bb3;
  flex-shrink: 0;
  width: 36px;
}

.status-badge {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;

  &.bidding {
    background: rgba(0, 212, 255, 0.1);
    color: #00d4ff;
  }

  &.quoting {
    background: rgba(0, 229, 160, 0.1);
    color: #00e5a0;
  }

  &.auctioning {
    background: rgba(255, 107, 157, 0.1);
    color: #ff6b9d;
  }

  &.evaluating {
    background: rgba(240, 160, 48, 0.1);
    color: #f0a030;
  }

  &.finished {
    background: rgba(140, 155, 179, 0.1);
    color: #8c9bb3;
  }
}

.op-btn {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  border: none;
  margin-right: 6px;
  transition: all 0.2s;

  &.primary {
    background: rgba(0, 212, 255, 0.15);
    color: #00d4ff;

    &:hover {
      background: rgba(0, 212, 255, 0.3);
    }
  }

  &:not(.primary) {
    background: rgba(140, 155, 179, 0.1);
    color: #8c9bb3;

    &:hover {
      background: rgba(0, 212, 255, 0.1);
      color: #00d4ff;
    }
  }
}

/* ==================== 分页 ==================== */
.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 212, 255, 0.08);
  margin-top: 8px;
}

.footer-info {
  font-size: 12px;
  color: #8c9bb3;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 6px;
}

.page-btn {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid rgba(0, 212, 255, 0.2);
  background: transparent;
  color: #8c9bb3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: #00d4ff;
    color: #00d4ff;
    background: rgba(0, 212, 255, 0.08);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.page-num {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #8c9bb3;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s;

  &:hover {
    border-color: rgba(0, 212, 255, 0.3);
    color: #00d4ff;
  }

  &.active {
    background: rgba(0, 212, 255, 0.15);
    border-color: #00d4ff;
    color: #00d4ff;
  }
}

/* ==================== 响应式 ==================== */
@media (max-width: 1400px) {
  .stat-row {
    grid-template-columns: repeat(3, 1fr);
  }

  .chart-row:nth-of-type(2),
  .chart-row:nth-of-type(3) {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .stat-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .chart-body {
    min-height: 200px;
  }

  .op-btn {
    padding: 2px 6px;
    font-size: 10px;
    margin-right: 3px;
  }
}
</style>